var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-wrapper",on:{"mouseleave":_vm.handleMouseOut}},[_c('BaseHeader'),_c('div',{staticClass:"height-box"}),_c('router-view'),_c('BaseFooter'),_c('Call'),_c('MessageAlert',{directives:[{name:"show",rawName:"v-show",value:(_vm.alert),expression:"alert"}],on:{"close":_vm.close}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }